import React, { useEffect, useState } from "react";
import { TbBrandTwilio } from "react-icons/tb"; // Importing the Twilio brand icon from react-icons
import { useProperty } from "../../../../Contexts/PropertyContext/PropertyContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { apiClient } from "../../../../api";
import { baseUrl } from "../../../../Environments/environment";
import { ThreeDot } from "react-loading-indicators";
import { Switch } from "@headlessui/react";

const RequireFieldSetting = () => {
  const { selectedPropertyId } = useProperty();

  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(false);
  const [firstName, setFirstName] = useState(false);
  const [lastName, setLastName] = useState(false);
  const [isSave, setIsSave] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    if (!selectedPropertyId) {
      navigate("/propertyhome");
      toast.warn("Select the property first!!");
    }
  }, [selectedPropertyId, navigate]);
  useEffect(() => {
    if (selectedPropertyId) {
      fetchPropertyData(selectedPropertyId);
    }
  }, [selectedPropertyId]);
  const fetchPropertyData = async (propertyId) => {
    setLoading(true);
    try {
      const response = await apiClient.get(
        `${baseUrl}/requireFieldSetting/${propertyId}`
      );

      if (response.status === 200) {
        const setting = response.data.result.setting;
        console.log("setting", setting);
        setEmail(setting.email);
        setFirstName(setting.firstName);
        setLastName(setting.lastName);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Error fetching property data.";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleRequireFields = async () => {
    try {
      setIsSave(true);
      const token = localStorage.getItem("accessToken");

      const response = await apiClient.put(
        `${baseUrl}/requireFieldSetting/${selectedPropertyId}`,
        {
          email,
          firstName,
          lastName,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.statusCode === 200) {
        toast.success("Require Field Setting saved successfully!");
        // Reset form

        // Refresh review jobs
        fetchPropertyData(selectedPropertyId);
      }
    } catch (error) {
      console.error("Error updating require field setting:", error);
      const errorMessage =
        error.response?.data?.message ||
        "Failed to update require field setting";
      toast.error(errorMessage);
    } finally {
      setIsSave(false);
    }
  };

  return (
    <>
      <div className="bg-gray-100 p-4 sm:p-6 lg:p-8 xl:p-12">
        <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 sm:p-6">
          {loading ? (
            <div className="flex flex-row justify-center items-center py-8">
              <ThreeDot
                variant="brick-stack"
                color="#4f46e5"
                size="medium"
                text=""
                textColor=""
              />
            </div>
          ) : (
            <>
              <div className="w-full">
                <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 mb-4 sm:mb-6">
                  Require Field Setting
                </h2>

                {/* Twilio Details Section */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6 text-gray-800">
                  <div className="mt-4 sm:mt-6 flex items-center justify-between">
                    <label className="text-gray-800 font-bold text-base sm:text-lg">
                      First Name
                    </label>
                    <Switch
                      checked={firstName}
                      onChange={setFirstName}
                      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                    >
                      <span
                        aria-hidden="true"
                        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                      />
                    </Switch>
                  </div>
                  <div className="mt-4 sm:mt-6 flex items-center justify-between">
                    <label className="text-gray-800 font-bold text-base sm:text-lg">
                      Last Name
                    </label>
                    <Switch
                      checked={lastName}
                      onChange={setLastName}
                      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                    >
                      <span
                        aria-hidden="true"
                        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                      />
                    </Switch>
                  </div>
                  <div className="mt-4 sm:mt-6 flex items-center justify-between">
                    <label className="text-gray-800 font-bold text-base sm:text-lg">
                      Email
                    </label>
                    <Switch
                      checked={email}
                      onChange={setEmail}
                      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
                    >
                      <span
                        aria-hidden="true"
                        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
                      />
                    </Switch>
                  </div>
                </div>

                <button
                  className="bg-indigo-600 hover:bg-indigo-500 text-white font-medium px-4 py-2 text-sm sm:text-base rounded-md focus:outline-none transition-all w-full sm:w-auto"
                  onClick={handleRequireFields}
                >
                  {isSave ? "Saving..." : "Save"}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default RequireFieldSetting;
